const IS_CHECKLIST_ACTIVITY_FLAG = 1;
const IS_ADDITIONAL_ACTIVITY_FLAG = 0;

export default class ChecklistCriteria {
  constructor(filterChecklistActivitiesFlag) {
    this.filterChecklistActivitiesFlag = filterChecklistActivitiesFlag;
  }

  meetCriteria(activities) {
    if (this.filterChecklistActivitiesFlag) {
      return activities.filter(
        (activity) => activity.inventario === IS_CHECKLIST_ACTIVITY_FLAG,
      );
    }

    return activities.filter(
      (activity) => activity.inventario === IS_ADDITIONAL_ACTIVITY_FLAG,
    );
  }
}
